export default "__VITE_ASSET__BM67Uyi0__"